/**
 * reportApis
 *
 * Static API endpoint map for reports that use a **single** endpoint for all
 * report types (the graph endpoint is derived automatically by appending
 * "graphic-data/" to the base URL).
 *
 * Usage in ReportLayoutHandler:
 *   <ReportLayoutHandler source_id="my_report" />
 *   → looks up reportApis["my_report"] as the base URL
 *
 * For reports that need **different endpoints per report type** (e.g. a daily
 * vs. monthly endpoint split), expose `customApi` and/or `customGraphApi` as
 * functions from the report's hook instead of registering a static entry here:
 *
 *   customApi: (reportType) =>
 *     reportType === "daily" ? DAILY_API : MONTHLY_API
 *
 * See useTransactionSummaryReport for a concrete example.
 */
export const reportApis: Record<string, string> = {
  // Add single-endpoint report APIs here, keyed by the source_id / route id
  // used when rendering <ReportLayoutHandler source_id="..." />.
  //
  // Example:
  //   merchant_velocity: "reports/merchant-monthly-velocity-reports/",
};
